import { State } from 'src/types'
import { edges } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/front/edge'
import { webTop, webBottom } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/front/web'
import { catchFace } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/front/catchFace'
import { thumbHook } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/front/hook'
import { thumbBackOut, backAroundWeb } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/front/thumbBack'
import { stitch } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/front/stitch'
import { laces } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/front/lace'
import { webCross } from 'src/features/atoms/glove/drawer/rightThrow/firstmitt/front/lace/webCross'
import { canvasResetter } from 'src/util/canvas'
import { atomsEngravedOfCatchFaceOfJaModel } from '../../../labels/atoms'

export const atomsCanvasFirstMittFrontLeftThrow = async (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): Promise<void> => {
  if (!state.underWeb) return
  if (!state.thumb) return
  // リセット
  canvasResetter(ctx)
  ctx.translate(canvasWidth, 0)
  ctx.scale(-1, 1)

  const laceColor = state.lace.color

  // 革紐＿ウェブ間クロス＿上段
  webCross(ctx, laceColor, 0, 0)
  webCross(ctx, laceColor, 60, -50)
  // 革紐＿ウェブ間クロス＿下段
  webCross(ctx, laceColor, -40, -75)
  webCross(ctx, laceColor, 20, -120)
  // 捕球面
  catchFace(ctx, state.catchFace.color)

  const printLeatherTypeValue = state.printLeatherType?.value
  // ウェブ先端側
  await webTop(ctx, state.web.color, printLeatherTypeValue)
  // ウェブ捕球面側
  await webBottom(ctx, state.web2.color, printLeatherTypeValue)
  // 背面＿ウェブ周り
  backAroundWeb(ctx, state.underWeb.color)
  // 親指背面＿外側
  thumbBackOut(ctx, state.thumb.color)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color)
  // ヘリ革
  edges(ctx, state.edge.color)
  // ステッチ
  stitch(ctx, state.stitch.color)
  // 革紐
  laces(ctx, laceColor)
  ctx.scale(-1, 1) // 元に戻す
  ctx.translate(-canvasWidth, 0)

  atomsEngravedOfCatchFaceOfJaModel(ctx, -60, 8, state.catchFace?.color)
}
